// src/components/Team_Details.jsx
import React from 'react';
import './Team_Details.css';

import Header from './Header';  

import DrShuHu from '../assets/Dr_Shu_Hu.png';
import LiLin from '../assets/Li_Lin.png';
import ShailDesai from '../assets/Shail_Desai.png';
import AdityaPawar from '../assets/Aditya_Pawar.png';

import researchIcon from '../assets/research.png';
import webIcon from '../assets/web.png';

function Team_Details() {
  const citation = `@inproceedings{lin2025aiface,
  title={AI-Face: A Million-Scale Demographically Annotated AI-Generated Face Dataset and Fairness Benchmark},
  author={Li Lin and Santosh and Mingyang Wu and Xin Wang and Shu Hu},
  booktitle={Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},
  year={2025}
}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(citation);
    alert('Citation copied to clipboard!');
  };

  return (
    <div className="team-container">
      <div className="team-content">
        {/* Shared Header */}
        <Header activeLink="Team" />

        {/* Team Section */}
        <section className="section-box">
          <h1 className="team-title">Meet Our Team</h1>
          <h2 className="section-heading">Project Leadership</h2>
          <div className="team-grid">
            <TeamCard img={DrShuHu} name="Dr. Shu Hu" title="Director, M2 Lab" subtitle="Purdue University" />
            <TeamCard img={LiLin} name="Li Lin" title="Project Manager" subtitle="Algorithm Design Engineer" />
          </div>

          <h2 className="section-heading">Technical Team</h2>
          <div className="team-grid">
            <TeamCard img={ShailDesai} name="Shail Desai" title="Software Engineer" subtitle="Backend / Front–End" />
            <TeamCard img={AdityaPawar} name="Aditya Pawar" title="Front–End Engineer" />
          </div>
        </section>

        {/* Resources */}
        <section className="section-box">
          <h2 className="section-heading">Resources</h2>
          <div className="team-grid">
            <ResourceCard
              img={researchIcon}
              name="Research Paper"
              title="AI-Face CVPR 2025"
              onClick={() => window.open('https://arxiv.org/pdf/2406.00783', '_blank')}
            />
            <ResourceCard
              img={webIcon}
              name="Dr. Shu Hu’s Website"
              title="Purdue University"
              onClick={() => window.open('https://web.ics.purdue.edu/~hu968/', '_blank')}
            />
          </div>
        </section>

        {/* Citation */}
        <section id="citation-section" className="section-box">
          <h2 className="section-heading">Citation</h2>
          <div className="citation-wrapper">
            <pre className="citation-box">{citation}</pre>
            <button className="copy-btn" onClick={copyToClipboard}>
              Copy
            </button>
          </div>
        </section>

        {/* Contact */}
        <section className="section-box contact-section">
          For inquiries or collaboration, contact us at:{" "}
          <a href="mailto:m2lab.purdue@gmail.com">m2lab.purdue@gmail.com</a>
        </section>
      </div>

      {/* Footer */}
      <footer className="footer-section">
        <div className="footer-left">© 2025 Purdue University</div>
        <div className="footer-center">
          Developed by Machine Learning and Media Forensics (M2) Lab from Purdue University
        </div>
        <div className="footer-right">
          <button
            className="footer-link"
            onClick={() => alert('Privacy Policy page not yet available.')}
          >
            Privacy Policy
          </button>
          {" | "}
          <button
            className="footer-link"
            onClick={() => alert('Terms of Use page not yet available.')}
          >
            Terms of Use
          </button>
          {" | "}
          <button
            className="footer-link"
            onClick={() => alert('Contact page not yet available.')}
          >
            Contact
          </button>
        </div>
      </footer>
    </div>
  );
}

const TeamCard = ({ img, name, title, subtitle }) => (
  <div className="team-card">
    <div className="image-glow">
      <img src={img} alt={name} />
    </div>
    <h3>{name}</h3>
    <p>{title}</p>
    {subtitle && <p>{subtitle}</p>}
  </div>
);

const ResourceCard = ({ img, name, title, onClick }) => (
  <div
    className="team-card clickable"
    onClick={onClick}
    style={{ cursor: 'pointer' }}
  >
    <div className="image-glow">
      <img src={img} alt={name} />
    </div>
    <h3>{name}</h3>
    <p>{title}</p>
  </div>
);

export default Team_Details;
